<template>
  <section>
    <b-modal :active.sync="isComponentEditActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p class="modal-card-title">Editar Perfil</p>
        </header>
        <section class="modal-card-body" v-if="user">
          <b-field label="Nombre">
            <b-input
              type="text"
              :value="user.name"
              v-model="user.name"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
          <b-field label="Apellido Paterno">
            <b-input
              type="text"
              :value="user.apepat"
              v-model="user.apepat"
              placeholder="Apellido Paterno"
              required
            ></b-input>
          </b-field>
          <b-field label="Apellido Materno">
            <b-input
              type="text"
              :value="user.apemat"
              v-model="user.apemat"
              placeholder="Apellido Materno"
              required
            ></b-input>
          </b-field>
          <b-field label="Rut">
            <b-input type="text" :value="user.rut" v-model="user.rut" placeholder="RUT" required></b-input>
          </b-field>
          <b-field label="Email">
            <b-input
              type="email"
              :value="user.email"
              v-model="user.email"
              placeholder="Your email"
              required
            ></b-input>
          </b-field>
         
         
       
        
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeEdit()">Cerrar</button>
          <button class="button is-primary" @click="editUser()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: ["isComponentEditActive", "closeEdit", "user_id", "nameUserConnect"],
  data() {
    return {
      user: null,
      
      isLoading:true
    };
  },
  created: function() {
     this.chargeUserData().then(()=>{
          this.isLoading=false;
        });
  },
  methods: {
    
    editUser: function() {
      this.isLoading=true;
      let data = {
        ...this.user
      };
      this.$http.put(`api/${localStorage.getItem('perfil')}/user/` + this.user_id, data).then(
        response => {
          //Limpia el objeto User
          for (const i in this.user) {
            this.user[i] = "";
          }
          window.localStorage.setItem("user",JSON.stringify(response.body.user));
           window.localStorage.setItem("userName",
          `${response.body.user.name} ${response.body.user.apepat} ${response.body.user.apemat}`
          );
          this.closeEdit();
          this.nameUserConnect();
          this.toast("Editado el Usuario", "is-success");
          this.isLoading=false;
        },
        response => {
          console.log(response);
          this.toast("error al editar", "is-danger");
          this.isLoading=false;
        }
      );
    },
    
    chargeUserData: async function() {
      await this.$http.get(`api/${localStorage.getItem('perfil')}/user/` + this.user_id).then(
          
        response => {
      
            this.user = response.body.user
         
        },
        response => {
          console.log(response);
        }
      );
    }
  }
};
</script>